export const selectCurrentChannel = (state) => state.channels.currentChannel;
export const selectChannelsLoading = (state) => state.channels.loading;
export const selectChannels = (state) => state.channels.channels;
export const selectChannelSubcategories = (state) => state.channels.subcategories;
